import DeleteWatchListEntryModal from './DeleteWatchListEntryModal';

export default DeleteWatchListEntryModal;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/components/delete-watch-list-entry-modal/index.js